/**
 * Generated by orval v8.21.0 🍺
 * Do not edit manually.
 * FINRA Market Data API
 * Market data aggregation backend for FINRA data sources
 * OpenAPI spec version: 0.1.0
 */
import {
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  ETFExploreTable,
  EquityExploreTable,
  GetETFExploreTableParams,
  GetEquityExploreTableParams,
  GetMutualFundExploreTableParams,
  HTTPValidationError,
  InternalErrorResponse,
  InvalidRequestErrorResponse,
  MutualFundExploreTable,
  UpstreamAuthenticationFailedErrorResponse,
  UpstreamBadGatewayErrorResponse,
  UpstreamUnavailableErrorResponse
} from '../fINRAMarketDataAPI.schemas.ts';

import { apiFetch } from '../../../lib/api-client.ts';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export type getEquityExploreTableResponse200 = {
  data: EquityExploreTable
  status: 200
}

export type getEquityExploreTableResponse400 = {
  data: InvalidRequestErrorResponse
  status: 400
}

export type getEquityExploreTableResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type getEquityExploreTableResponse500 = {
  data: UpstreamAuthenticationFailedErrorResponse | InternalErrorResponse
  status: 500
}

export type getEquityExploreTableResponse502 = {
  data: UpstreamBadGatewayErrorResponse
  status: 502
}

export type getEquityExploreTableResponse503 = {
  data: UpstreamUnavailableErrorResponse
  status: 503
}

export type getEquityExploreTableResponseSuccess = (getEquityExploreTableResponse200) & {
  headers: Headers;
};
export type getEquityExploreTableResponseError = (getEquityExploreTableResponse400 | getEquityExploreTableResponse422 | getEquityExploreTableResponse500 | getEquityExploreTableResponse502 | getEquityExploreTableResponse503) & {
  headers: Headers;
};

export type getEquityExploreTableResponse = (getEquityExploreTableResponseSuccess | getEquityExploreTableResponseError)

export const getGetEquityExploreTableUrl = (params: GetEquityExploreTableParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/explore-table/equity?${stringifiedParams}` : `/api/v1/explore-table/equity`
}

/**
 * Get the equity explore table response for a single sort configuration.
 *
 * Returns up to the requested number of equities sorted by the given key,
 * optionally filtered by sector. Each row includes ticker, name, price,
 * 5-year return, 1-year return, and market cap.
 *
 * Args:
 *     sort_by: Sort key — "price", "return_5y", "return_1y", or "market_cap".
 *     order_by: Sort direction — "asc" or "desc". Defaults to "desc".
 *     sector_slug: Optional sector slug (e.g. "technology", "healthcare") to filter results.
 *                  Omit to return results across all sectors.
 *     limit: Number of rows to return. Must be between 1 and 10.
 *     morningstar: Injected MorningstarClient instance
 *
 * Returns:
 *     EquityExploreTable with a single sorted list of EquityRow.
 *
 * Raises:
 *     400: sort_by is not a valid sort key
 *     500: Morningstar API error or authentication failure
 * @summary Get Equity Explore Table
 */
export const getEquityExploreTable = async (params: GetEquityExploreTableParams, options?: RequestInit): Promise<getEquityExploreTableResponse> => {

  return apiFetch<getEquityExploreTableResponse>(getGetEquityExploreTableUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetEquityExploreTableQueryKey = (params?: GetEquityExploreTableParams,) => {
    return [
    `/api/v1/explore-table/equity`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetEquityExploreTableQueryOptions = <TData = Awaited<ReturnType<typeof getEquityExploreTable>>, TError = InvalidRequestErrorResponse | HTTPValidationError | UpstreamAuthenticationFailedErrorResponse | InternalErrorResponse | UpstreamBadGatewayErrorResponse | UpstreamUnavailableErrorResponse>(params: GetEquityExploreTableParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEquityExploreTable>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEquityExploreTableQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEquityExploreTable>>> = ({ signal }) => getEquityExploreTable(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEquityExploreTable>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetEquityExploreTableQueryResult = NonNullable<Awaited<ReturnType<typeof getEquityExploreTable>>>
export type GetEquityExploreTableQueryError = InvalidRequestErrorResponse | HTTPValidationError | UpstreamAuthenticationFailedErrorResponse | InternalErrorResponse | UpstreamBadGatewayErrorResponse | UpstreamUnavailableErrorResponse


export function useGetEquityExploreTable<TData = Awaited<ReturnType<typeof getEquityExploreTable>>, TError = InvalidRequestErrorResponse | HTTPValidationError | UpstreamAuthenticationFailedErrorResponse | InternalErrorResponse | UpstreamBadGatewayErrorResponse | UpstreamUnavailableErrorResponse>(
 params: GetEquityExploreTableParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEquityExploreTable>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEquityExploreTable>>,
          TError,
          Awaited<ReturnType<typeof getEquityExploreTable>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEquityExploreTable<TData = Awaited<ReturnType<typeof getEquityExploreTable>>, TError = InvalidRequestErrorResponse | HTTPValidationError | UpstreamAuthenticationFailedErrorResponse | InternalErrorResponse | UpstreamBadGatewayErrorResponse | UpstreamUnavailableErrorResponse>(
 params: GetEquityExploreTableParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEquityExploreTable>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEquityExploreTable>>,
          TError,
          Awaited<ReturnType<typeof getEquityExploreTable>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEquityExploreTable<TData = Awaited<ReturnType<typeof getEquityExploreTable>>, TError = InvalidRequestErrorResponse | HTTPValidationError | UpstreamAuthenticationFailedErrorResponse | InternalErrorResponse | UpstreamBadGatewayErrorResponse | UpstreamUnavailableErrorResponse>(
 params: GetEquityExploreTableParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEquityExploreTable>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Equity Explore Table
 */

export function useGetEquityExploreTable<TData = Awaited<ReturnType<typeof getEquityExploreTable>>, TError = InvalidRequestErrorResponse | HTTPValidationError | UpstreamAuthenticationFailedErrorResponse | InternalErrorResponse | UpstreamBadGatewayErrorResponse | UpstreamUnavailableErrorResponse>(
 params: GetEquityExploreTableParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEquityExploreTable>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetEquityExploreTableQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type getMutualFundExploreTableResponse200 = {
  data: MutualFundExploreTable
  status: 200
}

export type getMutualFundExploreTableResponse400 = {
  data: InvalidRequestErrorResponse
  status: 400
}

export type getMutualFundExploreTableResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type getMutualFundExploreTableResponse500 = {
  data: UpstreamAuthenticationFailedErrorResponse | InternalErrorResponse
  status: 500
}

export type getMutualFundExploreTableResponse502 = {
  data: UpstreamBadGatewayErrorResponse
  status: 502
}

export type getMutualFundExploreTableResponse503 = {
  data: UpstreamUnavailableErrorResponse
  status: 503
}

export type getMutualFundExploreTableResponseSuccess = (getMutualFundExploreTableResponse200) & {
  headers: Headers;
};
export type getMutualFundExploreTableResponseError = (getMutualFundExploreTableResponse400 | getMutualFundExploreTableResponse422 | getMutualFundExploreTableResponse500 | getMutualFundExploreTableResponse502 | getMutualFundExploreTableResponse503) & {
  headers: Headers;
};

export type getMutualFundExploreTableResponse = (getMutualFundExploreTableResponseSuccess | getMutualFundExploreTableResponseError)

export const getGetMutualFundExploreTableUrl = (params: GetMutualFundExploreTableParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/explore-table/mutual-fund?${stringifiedParams}` : `/api/v1/explore-table/mutual-fund`
}

/**
 * Get the mutual fund explore table response for a single sort configuration.
 *
 * Returns up to the requested number of mutual funds sorted by the given key,
 * optionally filtered by sector. Each row includes ticker, name, expense ratio,
 * price, 5-year return, 1-year return, and fund size.
 *
 * Args:
 *     sort_by: Sort key — "expense_ratio", "price", "return_5y", "return_1y", or "fund_size".
 *     order_by: Sort direction — "asc" or "desc". Defaults to "desc".
 *     sector_slug: Optional sector slug (e.g. "technology", "healthcare") to filter results.
 *                  Omit to return results across all sectors.
 *     limit: Number of rows to return. Must be between 1 and 10.
 *     morningstar: Injected MorningstarClient instance
 *
 * Returns:
 *     MutualFundExploreTable with a single sorted list of MutualFundRow.
 *
 * Raises:
 *     400: sort_by is not a valid sort key
 *     500: Morningstar API error or authentication failure
 * @summary Get Mutual Fund Explore Table
 */
export const getMutualFundExploreTable = async (params: GetMutualFundExploreTableParams, options?: RequestInit): Promise<getMutualFundExploreTableResponse> => {

  return apiFetch<getMutualFundExploreTableResponse>(getGetMutualFundExploreTableUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetMutualFundExploreTableQueryKey = (params?: GetMutualFundExploreTableParams,) => {
    return [
    `/api/v1/explore-table/mutual-fund`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetMutualFundExploreTableQueryOptions = <TData = Awaited<ReturnType<typeof getMutualFundExploreTable>>, TError = InvalidRequestErrorResponse | HTTPValidationError | UpstreamAuthenticationFailedErrorResponse | InternalErrorResponse | UpstreamBadGatewayErrorResponse | UpstreamUnavailableErrorResponse>(params: GetMutualFundExploreTableParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMutualFundExploreTable>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMutualFundExploreTableQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMutualFundExploreTable>>> = ({ signal }) => getMutualFundExploreTable(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMutualFundExploreTable>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetMutualFundExploreTableQueryResult = NonNullable<Awaited<ReturnType<typeof getMutualFundExploreTable>>>
export type GetMutualFundExploreTableQueryError = InvalidRequestErrorResponse | HTTPValidationError | UpstreamAuthenticationFailedErrorResponse | InternalErrorResponse | UpstreamBadGatewayErrorResponse | UpstreamUnavailableErrorResponse


export function useGetMutualFundExploreTable<TData = Awaited<ReturnType<typeof getMutualFundExploreTable>>, TError = InvalidRequestErrorResponse | HTTPValidationError | UpstreamAuthenticationFailedErrorResponse | InternalErrorResponse | UpstreamBadGatewayErrorResponse | UpstreamUnavailableErrorResponse>(
 params: GetMutualFundExploreTableParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMutualFundExploreTable>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMutualFundExploreTable>>,
          TError,
          Awaited<ReturnType<typeof getMutualFundExploreTable>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMutualFundExploreTable<TData = Awaited<ReturnType<typeof getMutualFundExploreTable>>, TError = InvalidRequestErrorResponse | HTTPValidationError | UpstreamAuthenticationFailedErrorResponse | InternalErrorResponse | UpstreamBadGatewayErrorResponse | UpstreamUnavailableErrorResponse>(
 params: GetMutualFundExploreTableParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMutualFundExploreTable>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMutualFundExploreTable>>,
          TError,
          Awaited<ReturnType<typeof getMutualFundExploreTable>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMutualFundExploreTable<TData = Awaited<ReturnType<typeof getMutualFundExploreTable>>, TError = InvalidRequestErrorResponse | HTTPValidationError | UpstreamAuthenticationFailedErrorResponse | InternalErrorResponse | UpstreamBadGatewayErrorResponse | UpstreamUnavailableErrorResponse>(
 params: GetMutualFundExploreTableParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMutualFundExploreTable>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Mutual Fund Explore Table
 */

export function useGetMutualFundExploreTable<TData = Awaited<ReturnType<typeof getMutualFundExploreTable>>, TError = InvalidRequestErrorResponse | HTTPValidationError | UpstreamAuthenticationFailedErrorResponse | InternalErrorResponse | UpstreamBadGatewayErrorResponse | UpstreamUnavailableErrorResponse>(
 params: GetMutualFundExploreTableParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMutualFundExploreTable>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetMutualFundExploreTableQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type getETFExploreTableResponse200 = {
  data: ETFExploreTable
  status: 200
}

export type getETFExploreTableResponse400 = {
  data: InvalidRequestErrorResponse
  status: 400
}

export type getETFExploreTableResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type getETFExploreTableResponse500 = {
  data: UpstreamAuthenticationFailedErrorResponse | InternalErrorResponse
  status: 500
}

export type getETFExploreTableResponse502 = {
  data: UpstreamBadGatewayErrorResponse
  status: 502
}

export type getETFExploreTableResponse503 = {
  data: UpstreamUnavailableErrorResponse
  status: 503
}

export type getETFExploreTableResponseSuccess = (getETFExploreTableResponse200) & {
  headers: Headers;
};
export type getETFExploreTableResponseError = (getETFExploreTableResponse400 | getETFExploreTableResponse422 | getETFExploreTableResponse500 | getETFExploreTableResponse502 | getETFExploreTableResponse503) & {
  headers: Headers;
};

export type getETFExploreTableResponse = (getETFExploreTableResponseSuccess | getETFExploreTableResponseError)

export const getGetETFExploreTableUrl = (params: GetETFExploreTableParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/explore-table/etf?${stringifiedParams}` : `/api/v1/explore-table/etf`
}

/**
 * Get the ETF explore table response for a single sort configuration.
 *
 * Returns up to the requested number of ETFs sorted by the given key,
 * optionally filtered by sector. Each row includes ticker, name, expense
 * ratio, price, 5-year return, and 1-year return.
 *
 * Args:
 *     sort_by: Sort key — "expense_ratio", "price", "return_5y", or "return_1y".
 *     order_by: Sort direction — "asc" or "desc". Defaults to "desc".
 *     sector_slug: Optional sector slug (e.g. "technology", "healthcare") to filter results.
 *                  Omit to return results across all sectors.
 *     limit: Number of rows to return. Must be between 1 and 10.
 *     morningstar: Injected MorningstarClient instance
 *
 * Returns:
 *     ETFExploreTable with a single sorted list of ETFRow.
 *
 * Raises:
 *     400: sort_by is not a valid sort key
 *     500: Morningstar API error or authentication failure
 * @summary Get Etf Explore Table
 */
export const getETFExploreTable = async (params: GetETFExploreTableParams, options?: RequestInit): Promise<getETFExploreTableResponse> => {

  return apiFetch<getETFExploreTableResponse>(getGetETFExploreTableUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetETFExploreTableQueryKey = (params?: GetETFExploreTableParams,) => {
    return [
    `/api/v1/explore-table/etf`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetETFExploreTableQueryOptions = <TData = Awaited<ReturnType<typeof getETFExploreTable>>, TError = InvalidRequestErrorResponse | HTTPValidationError | UpstreamAuthenticationFailedErrorResponse | InternalErrorResponse | UpstreamBadGatewayErrorResponse | UpstreamUnavailableErrorResponse>(params: GetETFExploreTableParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getETFExploreTable>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetETFExploreTableQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getETFExploreTable>>> = ({ signal }) => getETFExploreTable(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getETFExploreTable>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetETFExploreTableQueryResult = NonNullable<Awaited<ReturnType<typeof getETFExploreTable>>>
export type GetETFExploreTableQueryError = InvalidRequestErrorResponse | HTTPValidationError | UpstreamAuthenticationFailedErrorResponse | InternalErrorResponse | UpstreamBadGatewayErrorResponse | UpstreamUnavailableErrorResponse


export function useGetETFExploreTable<TData = Awaited<ReturnType<typeof getETFExploreTable>>, TError = InvalidRequestErrorResponse | HTTPValidationError | UpstreamAuthenticationFailedErrorResponse | InternalErrorResponse | UpstreamBadGatewayErrorResponse | UpstreamUnavailableErrorResponse>(
 params: GetETFExploreTableParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getETFExploreTable>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getETFExploreTable>>,
          TError,
          Awaited<ReturnType<typeof getETFExploreTable>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetETFExploreTable<TData = Awaited<ReturnType<typeof getETFExploreTable>>, TError = InvalidRequestErrorResponse | HTTPValidationError | UpstreamAuthenticationFailedErrorResponse | InternalErrorResponse | UpstreamBadGatewayErrorResponse | UpstreamUnavailableErrorResponse>(
 params: GetETFExploreTableParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getETFExploreTable>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getETFExploreTable>>,
          TError,
          Awaited<ReturnType<typeof getETFExploreTable>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetETFExploreTable<TData = Awaited<ReturnType<typeof getETFExploreTable>>, TError = InvalidRequestErrorResponse | HTTPValidationError | UpstreamAuthenticationFailedErrorResponse | InternalErrorResponse | UpstreamBadGatewayErrorResponse | UpstreamUnavailableErrorResponse>(
 params: GetETFExploreTableParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getETFExploreTable>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Etf Explore Table
 */

export function useGetETFExploreTable<TData = Awaited<ReturnType<typeof getETFExploreTable>>, TError = InvalidRequestErrorResponse | HTTPValidationError | UpstreamAuthenticationFailedErrorResponse | InternalErrorResponse | UpstreamBadGatewayErrorResponse | UpstreamUnavailableErrorResponse>(
 params: GetETFExploreTableParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getETFExploreTable>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetETFExploreTableQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






